import { Navigate, Outlet } from "react-router-dom"
import Header from "../components/header-without-logo";
import Footer from "../components/footer";
import Helpers from "../services/helpers";
import SideBar from "../components/sideMenu";
import SubFooterWeb from "../components/sub-footerWeb";

const ProtectedLayoutNoFooter = () => {    
    const Token = Helpers.getTokenData();
    if (!Token?.access_token) {
        return <Navigate to="/login" replace />
    }

    return (
        <>            
            {/* <Header/>
            <div style={{marginBottom:'0px',marginTop:'70px'}}>
                <Outlet />
            </div>  */}

            <section className='sideBarSection'>
                <SideBar />
                <section className='mainContent'>
                    <Header />
                    <div className="webCastomMargen mb-0">
                        <Outlet />
                    </div>
                    <div className='WebFooter'>
                        <SubFooterWeb />
                    </div>
                </section>
            </section>          
        </>
    )
}

export default ProtectedLayoutNoFooter;